<div class="p-4">
  <p-table
    styleClass="p-datatable-gridlines p-datatable-sm"
    [value]="atividadeMensagens"
    [scrollable]="true"
    scrollHeight="600px"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr class="bg-gray-100">
        <th class="text-gray-700 text-sm">Data envio</th>
        <th class="text-gray-700 text-sm">Remetente</th>
        <th class="text-gray-700 text-sm">Destinatário</th>
        <th class="text-gray-700 text-sm">OS</th>
        <th class="text-gray-700 text-sm">Mensagem</th>
        <th class="text-gray-700 text-sm">Confirmação de Leitura</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-atividadeMensagem let-i="index">
      <tr>
        <td class="text-sm">{{ atividadeMensagem.dataEnvio | date : 'dd/MM/yyyy HH:mm' }}</td>
        <td class="text-sm">{{ atividadeMensagem.remetente }}</td>
        <td class="text-sm">{{ atividadeMensagem.destinatario }}</td>
        <td class="text-sm">{{ atividadeMensagem.assunto }}</td>
        <td class="text-sm">{{ atividadeMensagem.mensagem }}</td>
        <td class="text-sm">{{ atividadeMensagem.flagLeitura == true ? 'Sim' : 'Não' }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="mt-6">
    <label class="font-semibold block mb-2">Nova Mensagem:</label>
    <textarea
      class="w-full border border-gray-300 rounded p-2"
      rows="4"
      pInputTextarea
      [(ngModel)]="value">
    </textarea>

    <div class="mt-3">
      <p-button
        label="Salvar"
        icon="pi pi-save"
        severity="primary"
        (onClick)="onConfirm()"
        pTooltip="Salvar"
        tooltipPosition="top"
        [style]="{width: '120px'}">
      </p-button>
    </div>
  </div>
</div>
